import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteReasonRemarkComponent } from 'src/app/Account/delete-reason-remark/delete-reason-remark.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Transaction } from 'src/model/transaction.model';

@Component({
    selector: 'app-customer-bd-history',
    templateUrl: './customer-bd-history.component.html',
    styleUrls: ['./customer-bd-history.component.scss'],
    standalone: false
})
export class CustomerBdHistoryComponent implements OnInit {
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private cdr = inject(ChangeDetectorRef);


  bdTransactionList: Transaction[] = [];

  @Input() selectedProfileID: number;
  @Input() selectedCustomerName: string;
  @Input() isModal = true;
  isDirty = false;

  ngOnInit(): void {
    this.getAllTransactionsOfBD();
  }

  getAllTransactionsOfBD() {
    const xhttp = this.restApi.getRequest(this.constructApi.getProfileBDReceipts(this.selectedProfileID));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const receiptArray = JSON.parse((xhttp.responseText));

        receiptArray.forEach(receipt => {
          const transactionArray = JSON.parse(JSON.stringify(receipt.transactions));

          transactionArray.forEach(transaction => {
            const record = new Transaction(transaction.id, transaction.remark, transaction.amount,
              transaction.closingBalance, transaction.accountId, transaction.date, transaction.type, transaction.handleBy)

            this.bdTransactionList.push(record);
          });

          // var receiptObj = new Receipt(receipt.id, receipt.number, loanTransactionList);
          // this.receiptList.push(receiptObj);
        });
      }
    };
  }

  confirmDeleteTranscation(badDebt: Transaction) {
    const timeDiff = new Date().getTime() - new Date(badDebt.Date).getTime();
    const dateDiff = timeDiff / (1000 * 3600 * 24);
    if (dateDiff < 90 || this.sharedService.isBossAccount() == true) {
      const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
      modalRef.componentInstance.message = "Are you sure you want to delete SIMPAN BAD DEBT RM " + badDebt.Amount + "?";

      modalRef.result.then((confirm) => {
        if (confirm) {
          const modalRef = this.sharedService.openModal(DeleteReasonRemarkComponent);
          modalRef.componentInstance.transaction = badDebt;
          modalRef.componentInstance.passEntry.subscribe((entry) => {
            const remark = entry;

            //append added account to account list
            this.deleteTransaction(remark, badDebt.ID);
          });
        }}
      );
    }
    else
      this.sharedService.openAlert("This transaction is too old, please contact your admin to delete", ALERT_TYPE.DANGER)
  }

  deleteTransaction(remark: string, transactionID: number) {
    const data =
    {
      "reason": remark
    };

    const xhr = this.restApi.deleteRequest(this.constructApi.getDeleteBadDebtTransaction(transactionID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.readyState == 4 && xhr.status == 200) {
          if (xhr.status == 200) {
            this.removeTransctionFromList(transactionID);
            this.isDirty = true;
          }
          else {
            this.sharedService.openAlert("Opps, some errors occured. Please try again later", ALERT_TYPE.DANGER);
          }
        }
      }
    }
  }

  removeTransctionFromList(transactionId: number) {
    for (let i = 0; i < this.bdTransactionList.length; i++) {
      if (Number(this.bdTransactionList[i].ID) == transactionId) {
        this.bdTransactionList.splice(i, 1);
        this.cdr.detectChanges();

        if (this.bdTransactionList.length == 0)
          window.location.reload();
      }
    }
    return -1
  }

  calculateTotalBD(bdTransactionList: Transaction[]) {
    let sumOfReserve = 0;
    for (let i = 0; i < bdTransactionList.length; i++) {
      sumOfReserve += bdTransactionList[i].Amount;
    }
    return sumOfReserve;
  }

  checkAmountInOut(amount: number) {
    if (amount < 0)
      return 'negative';
    else
      return 'positive';
  }

  reset() {
    if (this.isDirty == true)
      window.location.reload();
    else
      this.activeModal.close();
  }
}
